import { ShoppingCartConfigurationBundleDto } from "@/api/models/shoppingCart.model";
import { ProductMultipleTransitionProcessService } from "@/api/services/productMultipleTransitionProcess.service";
import { AdditionalProductType } from "@/constants/additional-product-types.constants";
import { VoipNumberPoolStoreMutations } from "../voipNumberPool";
import { PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_ACTION, PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_STATE } from "./constants";

const clear = ({ commit }: any) => {
	commit(PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_STATE);

	commit(VoipNumberPoolStoreMutations.CLEAR);
};

const createProductOnlyMobilesTransition = ({ commit }: any, payload: { productId: string; transition: any; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.create({ ...payload, additionalProductType: AdditionalProductType.ONLY_MOBILES })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const createProductSharedMobilesTransition = ({ commit }: any, payload: { productId: string; transition: any; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.create({ ...payload, additionalProductType: AdditionalProductType.SHARED_MOBILES })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getProductMultipleTransitionById = ({ commit }: any, id: string) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.getById(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getMultipleTransitionProcessSummary = ({ commit }: any, { productId, shoppingCartId }: { productId: string; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.getMultipleTransitionProcessSummary({ productId, shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateMultipleTransition = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.update(payload.id, payload.data)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getMultipleTransitionConfiguration = ({ commit }: any, { productId, shoppingCartId }: { productId: string; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.getMultipleTransitionConfiguration({ productId, shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateMultipleTransitionConfiguration = (
	{ commit }: any,
	payload: { productId: string; shoppingCartId: string; bundles: ShoppingCartConfigurationBundleDto[] }
) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.putMultipleTransitionConfiguration(payload)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const sendMultipleTransition = ({ commit }: any, id: string) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.send(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveProductMultipleTransition = ({ commit }: any, transition: any) => {
	commit("setProductMultipleTransition", transition);
};

const saveProductMultipleTransitionShoppingCartId = ({ commit }: any, shoppingCartId: string) => {
	commit("setProductMultipleTransitionShoppingCartId", shoppingCartId);
};

const saveProductMultipleTransitionStatus = ({ commit }: any, status: string) => {
	commit("setProductMultipleTransitionStatus", status);
};

const deleteProductMultipleTransition = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductMultipleTransitionProcessService.delete(payload.id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

export default {
	[PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_ACTION]: clear,
	createProductOnlyMobilesTransition,
	createProductSharedMobilesTransition,
	getProductMultipleTransitionById,
	getMultipleTransitionProcessSummary,
	updateMultipleTransition,
	getMultipleTransitionConfiguration,
	updateMultipleTransitionConfiguration,
	sendMultipleTransition,
	saveProductMultipleTransition,
	saveProductMultipleTransitionShoppingCartId,
	saveProductMultipleTransitionStatus,
	deleteProductMultipleTransition
};
